module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12NgT0b/tc-custom/9780765390110.jpg?1738254552691",
      "alt": "This image is the cover for the book The Queen of Swords, Golgotha"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Queen of Swords, Golgotha\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("1720.")]), _vm._v(" Escaping the gallows, Anne Bonney, the infamous pirate queen, sets sail in search of a fabulous treasure said to be hiding in a lost city of bones somewhere in the heart of Africa. But what she finds is a destiny she never expected . . ."), _c('br'), _c('br'), _c('b', [_vm._v("1870.")]), _vm._v(" Maude Stapleton is a respectable widow raising a daughter on her own. Few know, however, that Maude belongs to an ancient order of assassins, the Daughters of Lilith, and heir to the legacy of Anne Bonney, whose swashbuckling exploits blazed a trail that Maude must now follow—if she ever wants to see her kidnapped daughter again!"), _c('br'), _c('br'), _vm._v(" Searching for her missing child, come hell or high water, Maude finds herself caught in the middle of a secret war between the Daughters of Lilith and their ancestral enemies, the monstrous Sons of Typhon, inhuman creatures spawned by primordial darkness, she embarks on a perilous voyage that will ultimately lead her to the long-lost secret of Anne Bonney—and the Father of All Monsters."), _c('br'), _c('br'), _vm._v(" One of the most popular characters from "), _c('i', [_vm._v("The Six-Gun Tarot")]), _vm._v(" and "), _c('i', [_vm._v("The Shotgun Arcana ")]), _vm._v("now ventures beyond the Weird West on a boldly imaginative, globe-spanning adventure of her own! ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R. S. Belcher\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0